import createWebStorage from 'redux-persist/lib/storage/createWebStorage';
const isNewRelicEnabled =
process.env.REACT_APP_NEW_RELIC_ENABLED === 'true';

export const environment = {
  production: false,
  graphql: '/graphql',
  session: { reminderInSeconds: 60 },
  bookingConfig: {
    // unique key vs admin app to prevent redux-persist collisions
    persistRoot: 'redux-store-client',
    timeout: 1,
    storage: createWebStorage('session'),
    whitelist: ['medQuestionnaire', 'travellerSelection', 'travellersDetails', 'travellersPlan', 'policyCreate']
  },
  covermeBookingConfig: {
    // unique key vs admin app to prevent redux-persist collisions
    persistRoot: 'redux-store-client-coverme',
    timeout: 1,
    storage: createWebStorage('session'),
    whitelist: [
      'quoteForm',
      'medQuestionnaire',
      'travellerSelection',
      'travellersDetails',
      'travellersPlan',
      'policyCreate',
      'recommendation',
      'quote'
    ]
  },
  maintenanceConfig: {
    persistRoot: 'redux-store-maintenance',
    timeout: 1,
    storage: createWebStorage('session'),
    whitelist: []
  },
  newRelic: isNewRelicEnabled
    ? {
      init: {
        distributed_tracing: {
          enabled: true,
          cors_use_newrelic_header: true,
          cors_use_tracecontext_headers: true
        },
        privacy: { cookies_enabled: true },
        ajax: { deny_list: [] }
      },
      info: {
        beacon: 'bam.nr-data.net',
        errorBeacon: 'bam.nr-data.net',
        licenseKey: process.env.REACT_APP_NEW_RELIC_LICENSE,
        applicationID: process.env.REACT_APP_NEW_RELIC_APP_ID,
        sa: 1
      },
      loader_config: {
        accountID: process.env.REACT_APP_NEW_RELIC_ACCOUNT_ID,
        trustKey: process.env.REACT_APP_NEW_RELIC_TRUST_KEY,
        agentID: process.env.REACT_APP_NEW_RELIC_AGENT_ID,
        licenseKey: process.env.REACT_APP_NEW_RELIC_LICENSE,
        applicationID: process.env.REACT_APP_NEW_RELIC_APP_ID
      }
    }
    : undefined
};

